export const MODULE_NAME = 'sectionDetails';
export const SEARCH_PAGE_SIZE = 50;
export const DEBOUNCE_SEARCH_MILLISECONDS = 2500;
export const HORIZONTAL_MENU = 'horizontal_menu';

export const FILTERS_PRODUCTS = {
  DEFAULT: 'default',
};

export const BEFORE_PRICE_DISCOUNT = 'beforePrice';
